import React, { useState, useEffect } from 'react';
import { useTheme, createUseStyles } from 'react-jss';
import PropTypes from 'prop-types';
import * as R from 'ramda';

import Container from '@components/Container';
import Loading from '@components/Base/Loading';

const useStyles = createUseStyles(({
  rem,
}) => ({
  container: {
    width: '75%',
    height: '100%',
    padding: [0, rem(24), rem(10), rem(24)],
  },
}), {
  name: 'PlaneGPS'
})

const PlaneGPS = (props) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const [loading, setLoading] = useState(false);

  const {
    data,
    trackinfo,
    className: classNameProp
  } = props;

  const index = R.pathOr(0, ['index'])(data);

  const getLine = data => {
    const lnglat = [];
    if (data && data.length === 0) return lnglat;
    if (data && data.length === 1) {
      const gpsInfo = R.pathOr({}, ['custom', 'gps'])(data[0]);
      const gps = {
        latitude: gpsInfo.lat,
        longitude: gpsInfo.lon,
        city: gpsInfo.city,
      };
      lnglat.push(gps);
      lnglat.push(gps);
      return lnglat;
    }
    if (data && data.length > 1) {
      data.forEach(item => {
        const gpsInfo = R.pathOr({}, ['custom', 'gps'])(item);
        const time = R.pathOr(new Date().getTime(), ['base', 'timestamp'])(item);
        const gps = {
          latitude: gpsInfo.lat,
          longitude: gpsInfo.lon,
          city: gpsInfo.city,
          time,
        };
        lnglat.push(gps);
      });
      // 根据时间排序
      lnglat.sort((a, b) => {
        return a.time - b.time;
      });
    }
    return lnglat;
  }

  const latlonData = getLine(trackinfo);
  const lat = R.pathOr('', [index, 'latitude'])(latlonData);
  const lon = R.pathOr('', [index, 'longitude'])(latlonData);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const initMap = (aMap, aMapUI) => {
    const map = new aMap.Map('plane', {
      resizeEnable: true,
      zoom: 8,
      center: [lon, lat], // 当前点的经纬度
      mapStyle: 'amap://styles/whitesmoke', // 初始化地图主题
    });

    aMapUI.load(['ui/misc/PathSimplifier', 'lib/$'], function(PathSimplifier, $) {
      if (!PathSimplifier.supportCanvas) {
        alert('当前环境不支持 Canvas！');
        return;
      }
      var pathSimplifierIns = new PathSimplifier({
        zIndex: 100,
        map: map, // 所属的地图实例
        getPath: function(pathData, pathIndex) {
          return pathData.path;
        },
        getHoverTitle: function(pathData, pathIndex, pointIndex) {
          if (pointIndex >= 0) {
            //point 
            return pathData.name + '，点：' + pointIndex + '/' + pathData.path.length;
          }
          return pathData.name + '，点数量' + pathData.path.length;
        },
        renderOptions: {
          renderAllPointsIfNumberBelow: 100 //绘制路线节点，如不需要可设置为-1
        }
      });

      window.pathSimplifierIns = pathSimplifierIns;

      //设置数据, 在A的时候就A,B的时候A到B, C的时候A到B到C
      if (index === 0) {
        pathSimplifierIns.setData([{
          name: '路线1',
          path: [
            [lon, lat],
            [lon, lat],
          ]
        }]);
      } else if (index === 1) {
        const aPoint = [R.pathOr('', [index - 1, 'longitude'])(latlonData), R.pathOr('', [index - 1, 'latitude'])(latlonData)];
        pathSimplifierIns.setData([{
          name: '路线2',
          path: [
            aPoint,
            [lon, lat],
          ]
        }]);
      } else {
        const aPoint = [R.pathOr('', [index - 2, 'longitude'])(latlonData), R.pathOr('', [index - 2, 'latitude'])(latlonData)];
        const bPoint = [R.pathOr('', [index - 1, 'longitude'])(latlonData), R.pathOr('', [index - 1, 'latitude'])(latlonData)];
        pathSimplifierIns.setData([{
          name: '路线3',
          path: [
            aPoint,
            bPoint,
            [lon, lat],
          ]
        }]);
      }

      //对第一条线路（即索引 0）创建一个巡航器
      var navg1 = pathSimplifierIns.createPathNavigator(0, {
        loop: true, //循环播放
        speed: 50000 //巡航速度，单位千米/小时
      });

      navg1.start();
    });

    // 加载插件
    map.plugin(['AMap.ToolBar'], () => {
      const toolbar = new aMap.ToolBar({
        position: 'RB',
      });
      map.addControl(toolbar);
    });

    setLoading(false);
  };

  useEffect(() => {
    const aMap = global.window.AMap;
    const aMapUI = global.window.AMapUI;
    setLoading(true);
    initMap(aMap, aMapUI);
  }, []);

  return (
    <Container 
      flex
      alignItems='center'
      direction='column'
      justify='center'
      className={classNameProp}
    >
      <div id='plane' className={classes.container} />
      {
        loading ? (<Loading size={0.5} /> ) : null
      }

    </Container>
  )
};

PlaneGPS.propTypes = {
  data: PropTypes.object.isRequired,
  trackinfo: PropTypes.oneOfType([
    PropTypes.object, 
    PropTypes.array,
  ]).isRequired,
  className: PropTypes.string,
}

export default PlaneGPS;
